import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const TextInput = ({
  input, label, placeholder, type, meta, ...custom
}) => {
  const { touched, error, warning } = meta;
  const hasError = touched && error !== undefined;

  return (
    <span>
      {React.createElement(Input, {
        ...input,
        error: hasError,
        fluid: true,
        placeholder,
        ...custom,
      })}

      {touched
        && ((error && <span className='error-text'>{error}</span>)
          || (warning && <span className='warn-text'>{warning}</span>))}
    </span>
  );
};

TextInput.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
    warning: PropTypes.string,
  }).isRequired,
};

export default TextInput;
